import { Callout } from '../../cdl/Callout/Callout';
import { StatusBar } from '../../cdl/StatusBar/StatusBar';
import { translate } from '../../common/helpers/translate.helper';
import { OfferModel } from '../model/OfferModel';
import { OfferState } from '../model/OfferState';

interface SupplierOfferDetailStatusBarProps {
    offer: OfferModel;
}

export const SupplierOfferDetailStatusBar = ({ offer }: SupplierOfferDetailStatusBarProps) => {
    if (offer.state === OfferState.CONFIRMED && offer.deliveryPast()) {
        return (
            <Callout
                variant="accent"
                heading={translate('statusbar.supplier.delivery.label')}
                description={translate('statusbar.supplier.delivery.subtitle')}
            />
        );
    }

    if (offer.state === OfferState.ENQUIRY_EXPIRED && offer.isSpot()) {
        return (
            <StatusBar
                variant="attention"
                headline={translate('statusbar.supplier.spotenquirycanceled.label')}
                subHeadline={translate('statusbar.supplier.spotenquirycanceled.subtitle')}
            />
        );
    }

    if (offer.state === OfferState.QUOTE_DECLINED && offer.isSpot()) {
        return (
            <StatusBar
                variant="attention"
                headline={translate('statusbar.supplier.spotqoutedeclined.label')}
                subHeadline={translate('statusbar.supplier.spotqoutedeclined.subtitle')}
            />
        );
    }

    switch (offer.state) {
        case OfferState.ENQUIRY: {
            const headlineTranslationKey = offer.isSpot()
                ? 'statusbar.supplier.spotenquiry.label'
                : 'statusbar.supplier.enquiry.label';

            const subHeadlineTranslationKey = offer.isSpot()
                ? 'statusbar.supplier.spotenquiry.subtitle'
                : 'statusbar.supplier.enquiry.subtitle';

            return (
                <StatusBar
                    variant="neutral"
                    headline={translate(headlineTranslationKey)}
                    subHeadline={translate(subHeadlineTranslationKey)}
                />
            );
        }
        case OfferState.QUOTED: {
            const headlineTranslationKey = offer.isSpot()
                ? 'statusbar.supplier.spotquoted.label'
                : 'statusbar.supplier.quoted.label';

            const subHeadlineTranslationKey = offer.isSpot()
                ? 'statusbar.supplier.spotquoted.subtitle'
                : 'statusbar.supplier.quoted.subtitle';

            return (
                <StatusBar
                    variant="neutral"
                    headline={translate(headlineTranslationKey)}
                    subHeadline={translate(subHeadlineTranslationKey)}
                />
            );
        }
        case OfferState.CONFIRMED: {
            return (
                <StatusBar
                    variant="neutral"
                    headline={translate('statusbar.supplier.confirmed.label')}
                    subHeadline={translate('statusbar.supplier.confirmed.subtitle')}
                />
            );
        }
        case OfferState.ORDER: {
            const headlineTranslationKey = offer.isSpot()
                ? 'statusbar.supplier.spotorder.label'
                : 'statusbar.supplier.order.label';

            const subHeadlineTranslationKey = offer.isSpot()
                ? 'statusbar.supplier.spotorder.subtitle'
                : 'statusbar.supplier.order.subtitle';

            return (
                <StatusBar
                    variant="neutral"
                    headline={translate(headlineTranslationKey)}
                    subHeadline={translate(subHeadlineTranslationKey)}
                />
            );
        }
        case OfferState.CUSTOMER_ADJUSTED: {
            return (
                <Callout
                    variant="default"
                    heading={translate('statusbar.supplier.customerAdjusted.label')}
                    description={translate('statusbar.supplier.customerAdjusted.subtitle')}
                />
            );
        }
        case OfferState.ACKNOWLEDGED: {
            return (
                <Callout
                    variant="accent"
                    heading={translate('statusbar.supplier.acknowledged.label')}
                    description={translate('statusbar.supplier.acknowledged.subtitle')}
                />
            );
        }
        case OfferState.DELIVERY_CONFIRMED: {
            return (
                <StatusBar
                    variant="positive"
                    headline={translate('statusbar.supplier.deliveryconfirmed.label')}
                    subHeadline={translate('statusbar.supplier.deliveryconfirmed.subtitle')}
                />
            );
        }
        case OfferState.QUOTE_CANCELED: {
            if (!offer.isSpot()) {
                return (
                    <StatusBar
                        variant="attention"
                        headline={translate('statusbar.supplier.enquirycanceled.label')}
                        subHeadline={translate('statusbar.supplier.enquirycanceled.subtitle')}
                    />
                );
            }

            return (
                <StatusBar
                    variant="attention"
                    headline={translate('statusbar.supplier.spotqoutedeclined.label')}
                    subHeadline={translate('statusbar.supplier.spotqoutedeclined.subtitle')}
                />
            );
        }
        case OfferState.ENQUIRY_CANCELED: {
            return (
                <StatusBar
                    variant="attention"
                    headline={translate('statusbar.supplier.enquirycanceled.label')}
                    subHeadline={translate('statusbar.supplier.enquirycanceled.subtitle')}
                />
            );
        }
        case OfferState.ENQUIRY_DECLINED: {
            return (
                <StatusBar
                    variant="attention"
                    headline={translate('statusbar.supplier.enquirydeclined.label')}
                    subHeadline={translate('statusbar.supplier.enquirydeclined.subtitle')}
                />
            );
        }
    }
    return null;
};
